//Voir plus pour les documents privées
const settings = {
  wrapper: '[js-list-doc]',
  wrapperDoc: '[js-doc-by-cat]',
  amount : 6
}

const wrapper = document.querySelector(settings.wrapper);

document.addEventListener("DOMContentLoaded", () => {
  if (wrapper) {
    let listDoc = wrapper.querySelectorAll(settings.wrapperDoc);

    listDoc.forEach(d => {
      let allDoc = d.querySelectorAll('.dl-doc');


      if (allDoc.length > settings.amount) {
        hideExceedingDocs(allDoc, settings.amount);

        const moreBtn = document.createElement('div');
        moreBtn.innerText = 'Voir tout';
        moreBtn.classList.add('btn');
        moreBtn.classList.add('btn--primary');
        moreBtn.setAttribute('data-current-state', 'hidden');

        d.appendChild(moreBtn);

        moreBtn.addEventListener('click', () => {
          if(moreBtn.getAttribute('data-current-state') === 'hidden') {
            showExceedingDocs(allDoc, settings.amount);
            moreBtn.innerText = 'Voir moins';
            moreBtn.setAttribute('data-current-state', 'displayed');
          } else {
            hideExceedingDocs(allDoc, settings.amount);
            moreBtn.innerText = 'Voir tout';
            moreBtn.setAttribute('data-current-state', 'hidden');
          }
        });

      }

    })

  }
});

const hideExceedingDocs = (allDoc, amount) => {
  allDoc.forEach((doc, index) => {
    if(index > amount - 1 ){
      doc.style.display = "none";
    }
  });
};

const showExceedingDocs = (allDoc, amount) => {
  allDoc.forEach((doc, index) => {
    if(index > amount - 1 ){
      doc.style.display = "block";
    }
  });
};


